var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-box__data",attrs:{"data-ci":"plan-box-data"}},[_c('MultiSubBoxDataHeader',{attrs:{"content":_vm.header,"classes":[
            _vm.hasFeatureList && _vm.isMobileDevice
                ? 'plan-box__line-divider is-mobile steps-header-message__blue'
                : 'is-mobile plan-box__line-divider',
        ]}}),_vm._v(" "),_c('FeatureList',{attrs:{"features":_vm.featureList}}),_vm._v(" "),(_vm.plan.legal_disclaimer && _vm.stepClass === 'cadence')?_c('div',{staticClass:"plan__disclaimer"},[_vm._v("\n        "+_vm._s(_vm.plan.legal_disclaimer)+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }